import { render, staticRenderFns } from "./InspectionContact.vue?vue&type=template&id=80e68c26&scoped=true&"
import script from "./InspectionContact.vue?vue&type=script&lang=js&"
export * from "./InspectionContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e68c26",
  null
  
)

export default component.exports